import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import ManagerNavBar from '../../Components/NavigationBar/ManagerNavBar';
import ManagerUsers from '../../Components/Manager/Administraction/ManagerUsers';
import ManagerDevices from '../../Components/Manager/Devices/ManagerDevices';
import ManagerFilesWorker from '../../Components/Manager/WorkerFiles/ManagerFilesWorker';
import ManagerContractors from './ManagerContractors';
import ManagerProducts from './ManagerProducts.js';
import RoundingRulesConfig from '../../Components/Manager/Attendance/RoundingRulesConfig';
import supabase from '../../supabaseClient';



// import License from '../../Components/Manager/Administration/License';
// import Settings from '../../Components/Manager/Administration/Settings';
// import Users from '../../Components/Manager/Administration/Users';


// import GroupIcon from '@mui/icons-material/Group';
// import PublicIcon from '@mui/icons-material/Public';
// import SettingsIcon from '@mui/icons-material/Settings';
// import EngineeringIcon from '@mui/icons-material/Engineering';
// import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'} variant={'body2'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


function ManagerAdministration() {

  const [value, setValue] = useState(0);
  const [idConfig, setIdConfiguration] = useState('');

  useEffect(() => {
    const init = async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      if (!sessionData.session) return;
      const userId = sessionData.session.user.id;
      const { data: profileData, error: profileError } = await supabase
        .from('profiles')
        .select('id_configuration')
        .eq('id', userId)
        .single();
      if (profileError || !profileData) {
        console.log('Błąd pobierania profilu:', profileError);
        return;
      }
      setIdConfiguration(profileData.id_configuration);
    };
    init();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleScrollRight = () => {
    if (value < 5) {
      setValue(value + 1);
    }
  };

  const handleScrollLeft = () => {
    if (value > 0) {
      setValue(value - 1);
    }
  };

  return (
    <ManagerNavBar>
      <Box sx={{ px: 6, py: 2 }}>
      <Typography sx={{ fontSize: '30px', fontWeight: 700, color: 'primary.main', mb: 3 }}>
                    Ustawienia
                </Typography>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            allowScrollButtonsMobile 
            variant="scrollable"
            scrollButtons
            sx={{ display: 'flex' }}
          >
            {/* <Tab icon={<PrecisionManufacturingIcon />} label={("Maszyny")} {...a11yProps(0)} />
            <Tab icon={<EngineeringIcon />} label={("Pracownicy")} {...a11yProps(1)} />
            <Tab icon={<GroupIcon />} label={("Użytkownicy")} {...a11yProps(2)} />
            <Tab icon={<PublicIcon />} label={("Licencja")} {...a11yProps(3)} />
            <Tab icon={<SettingsIcon />} label={("Ustawienia")} {...a11yProps(4)} /> */}
            <Tab label={("Kontrahenci")} {...a11yProps(0)} />
            <Tab label={("Produkty")} {...a11yProps(1)} />
            <Tab label={("Maszyny")} {...a11yProps(2)} />
            <Tab label={("Pracownicy")} {...a11yProps(3)} />
            <Tab label={("Użytkownicy")} {...a11yProps(4)} />
            <Tab label={("Licencja")} {...a11yProps(5)} />
            <Tab label={("Reguły obliczania czasu pracy")} {...a11yProps(6)} />

          </Tabs>
            <TabPanel value={value} index={0}  handleScrollLeft={handleScrollLeft} handleScrollRight={handleScrollRight}>
              <ManagerContractors></ManagerContractors>
            </TabPanel>
            <TabPanel value={value} index={1}  handleScrollLeft={handleScrollLeft} handleScrollRight={handleScrollRight}>
              <ManagerProducts></ManagerProducts>
            </TabPanel>
            <TabPanel value={value} index={2}  handleScrollLeft={handleScrollLeft} handleScrollRight={handleScrollRight}>
              <ManagerDevices></ManagerDevices>
            </TabPanel>
            <TabPanel value={value} index={3}  handleScrollLeft={handleScrollLeft} handleScrollRight={handleScrollRight}>
              <ManagerFilesWorker></ManagerFilesWorker>
            </TabPanel>
            <TabPanel value={value} index={4}  handleScrollLeft={handleScrollLeft} handleScrollRight={handleScrollRight}>
              <ManagerUsers></ManagerUsers>
            </TabPanel>
            <TabPanel value={value} index={5}  handleScrollLeft={handleScrollLeft} handleScrollRight={handleScrollRight}>
            {/* <License></License> */}
            </TabPanel>
            <TabPanel value={value} index={6}  handleScrollLeft={handleScrollLeft} handleScrollRight={handleScrollRight}>
              <RoundingRulesConfig idConfig={idConfig} />
            </TabPanel>

      </Box>
    </ManagerNavBar>
  );
}

export default ManagerAdministration;
